/**
 * Common UI i18n strings. Split into parts to respect max-lines (400).
 */

import { COMMON_UI_I18N_PART1 } from "./commonUiI18nPart1";
import { COMMON_UI_I18N_PART2 } from "./commonUiI18nPart2";

const COMMON_UI_I18N_RAW = {
	...COMMON_UI_I18N_PART1,
	...COMMON_UI_I18N_PART2,
} as const;

export const COMMON_UI_I18N: typeof COMMON_UI_I18N_RAW = COMMON_UI_I18N_RAW;
